import * as React from 'react';
import { Reliability } from '@cian/frontend-newbuilding-reliability-widget';
import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { DOM_RF_LINK } from '../../constants/externalLinks';
import { reliabilityEnabledSelector, reliabilitySelector } from '../../selectors/reliability';

export const ReliabilityV2Container = () => {
  const reliability = useSelector(reliabilitySelector);
  const reliabilityEnabled = useSelector(reliabilityEnabledSelector);

  if (!reliability || !reliabilityEnabled) {
    return null;
  }

  return (
    <Layout dataTestId="reliablev2">
      <div id="reliable">
        <Reliability
          title={reliability.checkStatus.title}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          status={reliability.checkStatus.status as any}
          date={reliability.checkStatus.date}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          details={reliability.details as any}
          domrfLink={DOM_RF_LINK}
        />
      </div>
    </Layout>
  );
};
